import { getComboDocAll, getComboList, getCombo, removeCombo, addCombo, editComboAndItem,moveCombo } from '@/api/combo'

class comboDTO {
    /**
     * 获取医联产品的全部医生
     */
    static getComboDocDTO() {
        return new Promise((resolve, reject) => {
            getComboDocAll().then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
     * 获取医联产品列表
     */
    static getComboListDTO(params) {
        return new Promise((resolve, reject) => {
            getComboList(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
     * 获取医联产品
     */
    static getComboDTO(comboId) {
        return new Promise((resolve, reject) => {
            getCombo(comboId).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
     * 删除医联产品
     */
    static removeComboDTO(comboId) {
        return new Promise((resolve, reject) => {
            removeCombo(comboId).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
     * 添加医联产品
     */
    static addComboDTO(params) {
        return new Promise((resolve, reject) => {
            addCombo(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
     * 修改医联产品和明细
     */
    static editComboAndItemDTO(params) {
        return new Promise((resolve, reject) => {
            editComboAndItem(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
     * 移动医联产品位置
     */
    static moveComboDTO(params) {
        return new Promise((resolve, reject) => {
            moveCombo(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
}

export { comboDTO }